import axios from "axios";
import { BASE_URL_API, SENSORS_URL } from "../config/env";
import {
  isFirstPartyApiRequestUrl as isFirstPartyApiRequestUrlForBase,
  shouldInvalidateSessionForError as shouldInvalidateSessionForApi,
} from "../utils/authFailure";

export { withExternalServiceAuthPolicy } from "../utils/authFailure";

axios.defaults.withCredentials = true;

const FCM_TOKEN_STORAGE_KEY = "iot-web-fcm-token";
let authToken = "";

export const setAuthToken = (token) => {
  authToken = typeof token === "string" ? token.trim() : "";
};

export const getAuthToken = () => authToken;

export const JSON_HEADERS = Object.freeze({
  "Content-Type": "application/json",
});

export const jsonRequestConfig = Object.freeze({
  headers: JSON_HEADERS,
});

export const isApiRequestUrl = (url) => {
  const value = String(url || "");
  return value.startsWith(BASE_URL_API) || value.startsWith("/");
};

export const isSensorsRequestUrl = (url) => {
  const value = String(url || "");
  return Boolean(SENSORS_URL && value.startsWith(SENSORS_URL));
};

export const isFirstPartyApiRequestUrl = (url) =>
  isFirstPartyApiRequestUrlForBase(url, BASE_URL_API);

export const shouldInvalidateSessionForError = (error) =>
  shouldInvalidateSessionForApi(error, BASE_URL_API);

export const withOrganizationHeaders = (config, org) => {
  if (!org?.id || !isApiRequestUrl(config?.url)) return config;

  return {
    ...config,
    headers: {
      ...(config?.headers || {}),
      "X-Org-Id": String(org.id),
      "X-Organization-Id": String(org.id),
    },
  };
};

axios.interceptors.request.use((config) => {
  const isApiRequest = isApiRequestUrl(config?.url);
  const isSensorsRequest = isSensorsRequestUrl(config?.url);
  if (!isApiRequest && !isSensorsRequest) return config;

  const fcmToken =
    typeof window !== "undefined"
      ? window.localStorage.getItem(FCM_TOKEN_STORAGE_KEY)
      : "";
  const currentAuthToken = getAuthToken();

  if (!fcmToken && !currentAuthToken) return config;

  return {
    ...config,
    headers: {
      ...(config?.headers || {}),
      ...(fcmToken ? { "X-FCM-Token": fcmToken } : {}),
      ...(currentAuthToken && !config?.headers?.Authorization
        ? { Authorization: `Bearer ${currentAuthToken}` }
        : {}),
    },
  };
});

export const apiClient = axios;

export default apiClient;
